import ImageResizer from 'react-native-image-resizer';
import {idPictureResize} from '../../../../config';

export const createResizedImage = async image => {
  const resizedImage = await ImageResizer.createResizedImage(
    `data:image/jpeg;base64,${image}`,
    idPictureResize.width,
    idPictureResize.height,
    'JPEG',
    idPictureResize.compressionRate,
  );

  return resizedImage?.path
    ? import('react-native-fs').then(RNFS =>
        RNFS.readFile(resizedImage.path, 'base64'),
      )
    : resizedImage;
};
